import { registerPlugin } from '@capacitor/core';

export interface WorkTimeLiveAcivityOptions{
    name: string, 
    time: number, 
    id: string, 
    token: string, 
    active: boolean
}

export interface WorkTimeLiveAcivity{
    start(options: WorkTimeLiveAcivityOptions):Promise<{result: boolean}>
}

const WorkTimeLiveAcivity = registerPlugin<WorkTimeLiveAcivity>('WorkTimeLiveAcivity');

export default WorkTimeLiveAcivity;